import React from 'react'
import Button from '@material-ui/core/Button'
import Tooltip from '@material-ui/core/Tooltip'
import StarIcon from '@material-ui/icons/Star'
import { useTranslation } from 'react-i18next'

import { useAuth } from '@graniot/common/context/AuthContext'
import DialogFreeTrial from '@graniot/common/components/map/dialog/DialogFreeTrial'

const GraniotPremiumButton = ({
	action,
	variant,
	color,
	size,
	style,
	endIcon,
	label
}) => {
	const { t } = useTranslation()
	const { loggedUser, isClientPaying } = useAuth()
	const [open, setOpen] = React.useState(false)

	return (
		<>
			{isClientPaying() || loggedUser.is_superuser ? (
				<Button
					onClick={action}
					variant={variant}
					color="primary"
					size="small"
					endIcon={endIcon}
					style={{ ...style }}
				>
					{t(label)}
				</Button>
			) : (
				<Button
					onClick={() => setOpen(true)}
					variant={variant}
					color="primary"
					startIcon={
						<Tooltip title={t('premium_features')}>
							<StarIcon style={{ color: 'orange' }} />
						</Tooltip>
					}
					endIcon={endIcon}
					style={{ ...style }}
				>
					{t(label)}
				</Button>
			)}
			<DialogFreeTrial open={open} setOpen={setOpen} />
		</>
	)
}

GraniotPremiumButton.defaultProps = {
	variant: 'contained',
	color: 'primary',
	size: 'small',
}

export default GraniotPremiumButton
